import React, {useState, Fragment} from 'react';
import {Form} from 'react-final-form';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import {Text, Select, Popup, Explanation_text} from '../../../components';
import {Field} from 'react-final-form';
import {connect} from 'react-redux';

function New_user_popup(props){
  const[purchase_message, setPurchaseMessage]=useState(false);

  function onSubmit(params){
    props.createTeamMember(params);
  }
  let current_subscription={};
  for(let s of props.subscriptions){if(props.workspace.active_subscription!=undefined && s.id==props.workspace.active_subscription.prospect_safari_service_id){current_subscription=s;}}
  let amount=current_subscription.amount;
  let interval='month'; if(current_subscription.subscription_interval=='YEAR'){interval='year';}
  let cost=current_subscription.currency+amount;
  let already_paid=false; if(props.workspace.active_subscription!=undefined && props.workspace.active_subscription.quantity>props.current_user_count){already_paid=true;}
  console.log('CURRENT USER COUNT!!!', props.current_user_count);
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{admin:true}}
    >
      {form_props => (
        <form onsubmit={form_props.handleSubmit}>
        <Popup accept_button={'Invite'} handleClose={props.handleClose} accept_button_click={()=>{if(purchase_message==false && (props.workspace.active_subscription==undefined || props.workspace.active_subscription.minimum_quantity<=props.current_user_count)){setPurchaseMessage(true);}else{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}} always_open title='team_setup_create_popup_title' content={
          (purchase_message==true)?
          <div style={{width:'100%', maxWidth:'600px', marginTop:'30px', marginBottom:'30px'}}>
          <Typography style={{paddingLeft:'30px', paddingRight:'30px'}}><Explanation_text placeholders={{cost:cost, interval:interval}} text='team_setup_create_popup_cost_short_explanation'/></Typography>
          </div>
          :<div style={{width:'100%', maxWidth:'600px', marginTop:'30px', marginBottom:'30px'}}>
          <Typography style={{textAlign:'center', marginBottom:'20px', marginTop:'-20px', width:'calc(100% - 60px)', marginLeft:'30px'}} color='primary'>{
            (props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial==true)?<Fragment>{"The additional charge for each user is "+cost+" a "+interval+". You won't be charged untill your free trial is over."}</Fragment>
            :(already_paid==true && props.workspace.active_subscription.minimum_quantity>props.current_user_count)?<Fragment>{"Additional users are included in your subscription plan."}</Fragment>:
            (already_paid==true)?<Fragment>{"Your current subscription includes "+props.workspace.active_subscription.quantity+" active users therefore you won't incur any extra charges. (The cost per active user is "+cost+" a "+interval+")."}</Fragment>
            :<Fragment>{"Your current subscription includes "+((props.workspace.active_subscription==undefined)?0:props.workspace.active_subscription.quantity)+" active users. Remember that once your new team member accepts your invitation, you will incur an extra cost of "+cost+" a "+interval+"."}<div style={{marginTop:'20px', color:"rgba(0, 0, 0, 0.87)"}}>If you don't wish to increase your user count and therefore incur an extra cost, you should first remove one of your current active users.</div></Fragment>
        }</Typography>
          <Grid container style={{width:'calc(100% - 60px)', marginLeft:'30px'}}>
            <Grid item xs={12} sm={6}><Text title='team_setup_first_name_label' name='first_name'/></Grid>
            <Grid item xs={12} sm={6}><Text title='team_setup_last_name_label' name='last_name'/></Grid>
            <Grid item xs={12}><Text title='team_setup_email_label' name='email'/></Grid>
            <Grid item xs={12} sm={6} style={{paddingLeft:'10px'}}><Field name='admin'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="team_setup_update_admin_label"/>}/>}</Field></Grid>
          </Grid>
          </div>
  }/>
    </form>
  )}</Form>
  )
}




export default connect(ss,dd)(New_user_popup);


function ss(state){
  return{
    subscriptions:state.account.subscriptions,
    refresh:state.workspaces.refresh,
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id]
  }
}

function dd(dispatch){
  return{
    createTeamMember:(data)=>{dispatch({type:'REQUEST_CREATE_TEAM_MEMBER', payload:data});}
  }
}
